import React, { useEffect, useRef } from "react";
import { Typography, Paper, Grid } from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import useStyles from "../../styles/dashboardStyle";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import SmallerLoadingIndicator from "../commons/SmallerLoadingIndicator";
import * as $ from "jquery";
import { NoDataText } from "../commons/ValidationText";
import useStateOnMounted from "../../helpers/useStateOnMounted";
import { useHistory } from "react-router-dom";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie, getElementAtEvent } from "react-chartjs-2";
import { useQueryParams } from "@/containers/Dashboard";
import { getDeviceCountByKioskMode } from "@/apis/apiCollection";
ChartJS.register(ArcElement, Tooltip, Legend);

const KioskMode = props => {
  const chartRef = useRef(null);
  let history = useHistory();
  const { t } = useTranslation("dashboard");
  const classes = useStyles();
  const cardTitleTypographyVariant = props.cardTitleTypographyVariant;
  const cardSubtitleTypographyVariant = props.cardSubtitleTypographyVariant;
  const graphGreen = "#1DBBD4";
  const graphOrange = "#ff9e40";
  const [kioskModeData, setKioskModeData] = useStateOnMounted();
  const [reload, setReload] = useStateOnMounted(true);
  const [queryParams, queryString] = useQueryParams();

  const enableText = t({ defaultMessage: "开启" });
  const disableText = t({ defaultMessage: "关闭" });

  const data = {
    labels: ["1", "0"],
    datasets: [
      {
        data: [kioskModeData?.openNum, kioskModeData?.closeNum],
        backgroundColor: [graphGreen, graphOrange],
        hoverBackgroundColor: [graphGreen, graphOrange]
      }
    ]
  };

  const options = {
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = "";
            if (context.label === "1") {
              label = enableText;
            } else if (context.label === "0") {
              label = disableText;
            }
            return label + ": " + context.parsed;
          }
        }
      }
    },
    onHover: function (e, item) {
      $(".pieChart canvas").css("cursor", item[0] ? "pointer" : "default");
    }
  };

  const clickHandler = event => {
    const { current: chart } = chartRef;
    const element = getElementAtEvent(chart, event);
    if (element) {
      const itemLabel = data?.labels[element[0]?.index];
      if (itemLabel) {
        history.push(
          `/groups/groups-devices?kiosk_mode=${itemLabel}${queryString}`
        );
      }
    }
  };

  const clickLabel = status => {
    history.push(`/groups/groups-devices?kiosk_mode=${status}${queryString}`);
  };

  const getKioskModeData = async () => {
    setReload(true);
    const data = await getDeviceCountByKioskMode({
      ...queryParams,
      includeChildCompany: Boolean(queryParams.hasSubCompanies)
    });
    if (data) {
      if (data.openNum === 0 && data.closeNum === 0) {
        setKioskModeData(false);
      } else {
        setKioskModeData(data);
      }
    } else {
      setKioskModeData(false);
    }
    setReload(false);
  };

  useEffect(() => {
    getKioskModeData();
  }, [queryParams]);

  return (
    <Paper elevation={0} style={{ justifyContent: "flex-start" }}>
      <Typography
        variant={cardTitleTypographyVariant}
        className={classes.cardTitleWrapWithReloadIcon}
      >
        {props.title}
        <AutorenewRoundedIcon
          onClick={getKioskModeData}
          size="small"
          className={classes.reload_btn}
        />
      </Typography>
      {!reload ? (
        kioskModeData ? (
          <Grid
            container
            spacing={2}
            alignItems="stretch"
            style={{ margin: "auto" }}
          >
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <div className="pieChart">
                <Pie
                  ref={chartRef}
                  data={data}
                  options={options}
                  onClick={clickHandler}
                />
              </div>
            </Grid>
            <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
              <Grid
                container
                spacing={2}
                alignItems="flex-start"
                className={classes.hardwareModelLabels}
                style={{ marginTop: "20px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  onClick={() => clickLabel(1)}
                >
                  <Paper
                    elevation={0}
                    className={`${classes.osTypeTitleBox} ${classes.heightInitial}`}
                  >
                    <div className="flex_align_center">
                      <Typography variant={cardSubtitleTypographyVariant}>
                        <span className="graphGreen colorCube"></span>
                        {enableText}
                      </Typography>
                      <Typography variant="h6">
                        <div className="ml-1">{kioskModeData.openNum}</div>
                      </Typography>
                    </div>
                  </Paper>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  onClick={() => clickLabel(0)}
                >
                  <Paper
                    elevation={0}
                    className={`${classes.osTypeTitleBox} ${classes.heightInitial}`}
                  >
                    <div className="flex_align_center">
                      <Typography variant={cardSubtitleTypographyVariant}>
                        <span className="graphOrange colorCube"></span>
                        {disableText}
                      </Typography>
                      <Typography variant="h6">
                        <div className="ml-1">{kioskModeData.closeNum}</div>
                      </Typography>
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <NoDataText />
        )
      ) : (
        <SmallerLoadingIndicator />
      )}
    </Paper>
  );
};

export default KioskMode;
